import React, { useContext, useLayoutEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../assets/logo.png";
import { AuthContext } from "../contexts/AuthContext";
import LanguageSwitcher from "../components/shared/LanguageSwitcher";
import { hasSavedLanguage } from "../i18n";

// Most visitors reaching this page from a report link are Danish; a
// first-time visitor gets Danish once, and their own choice is kept after.
let danishDefaultApplied = false;

const REASONS = ["login_required", "forbidden", "invalid_link", "not_found"];
const STATUS_BY_REASON = { login_required: 401, not_found: 404 };

const AccessDenied = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  const { isAuthenticated, isLoading } = useContext(AuthContext);

  useLayoutEffect(() => {
    if (!hasSavedLanguage && !danishDefaultApplied) {
      danishDefaultApplied = true;
      i18n.changeLanguage("da");
    }
  }, [i18n]);

  const reason = searchParams.get("reason");
  const messageKey = REASONS.includes(reason) ? reason : "default";
  const statusCode = STATUS_BY_REASON[reason] || 403;

  return (
    <div className="min-h-screen bg-greenLight flex items-center justify-center p-4 relative">
      <div className="absolute top-4 right-4">
        <LanguageSwitcher />
      </div>

      <div className="text-center max-w-md">
        <div className="mb-8 flex justify-center">
          <img src={logo} alt="Company Logo" className="h-16" />
        </div>

        <div className="text-6xl font-bold text-customgreen mb-4">{statusCode}</div>

        <div className="h-1 w-24 bg-buttonhover mx-auto mb-6"></div>

        <p className="text-gray-700 mb-8 px-4">{t(`accessDenied.${messageKey}`)}</p>

        {!isLoading && (
          <button
            onClick={() =>
              navigate(isAuthenticated ? "/dashboard" : "/login", { replace: true })
            }
            className="
              px-6 py-3
              bg-buttonhover
              text-white
              rounded-full
              hover:bg-buttonhover
              transition-colors
              shadow-md hover:shadow-lg
            "
          >
            {isAuthenticated ? t("accessDenied.backToDashboard") : t("accessDenied.signIn")}
          </button>
        )}
      </div>
    </div>
  );
};

export default AccessDenied;
